module.exports = __webpack_public_path__ + "img/gerstenberg_schroder.3542b334.png";